import styles from "../styles/pages/payment/RequestInvoiceForm.module.css";
import Footer from "./Footer";
import { IWidgetConfiguration } from "../merchantConfig";
import Button from "./Button";
import { IQuote } from "../@interfaces/purchase.interface";
import { TermsAndConditions } from "./TermsAndConditions";

interface RequestInvoiceFormProps {
  quote: IQuote;
  widgetConfiguration: IWidgetConfiguration;
  merchantCode: string;
}

const RequestInvoiceForm: React.FC<RequestInvoiceFormProps> = ({
  quote,
  widgetConfiguration,
  merchantCode
}) => {

  const amountSnippet = quote.requestedFor === "MONEY"
    ? `${quote.offsetPrice.value} ${quote.offsetPrice.currency} worth of carbon credits`
    : `${quote.carbonOffsetQuantity.value} ${quote.carbonOffsetQuantity.unit} CO₂e of carbon credits`;

  const estimationSnippet = quote.requestedFor === "MONEY"
    ? `It was estimated to amount to approximately ${quote.carbonOffsetQuantity.value} ${quote.carbonOffsetQuantity.unit} of CO₂e.`
    : `It was estimated to cost approximately ${quote.offsetPrice.value} ${quote.offsetPrice.currency}.`;

  const mailtoParams = new URLSearchParams({
    "subject": "Invoice request",
    "body": `Please generate an invoice for ${amountSnippet} from the basket with code ${quote.basket.code}. ${estimationSnippet}`
  });
  const mailtoLink = "mailto:info+invoice@carbonclick.com?" + mailtoParams.toString();
  return (<div className={styles.requestInvoiceContainer}>
    <div>
      <p className={styles.invoiceExplainer}>
        Due to the size of this contribution, you may request
        an invoice by clicking the button below. Details will be pre-populated. 
        Invoice requests are normally processed within 1 business day.
      </p>
    </div>
    <div>
      <Button
        variant={"primary"}
        text={`Request invoice`}
        href={mailtoLink}
      />
      <TermsAndConditions merchantCode={merchantCode} />
    </div>
    {!widgetConfiguration.hidePoweredBy && <Footer/>}
  </div>);
}

export default RequestInvoiceForm;
